// Types + option constants for the end-of-tournament feedback form.
// Hebrew labels are product copy (hardcoded, per project convention).

export type ReturnIntent = 'yes' | 'probably' | 'unsure' | 'no';

export interface FeedbackResponse {
  user_id: string;
  overall_rating: number;
  scoring_clarity: number;
  return_intent: ReturnIntent;
  return_blocker: string | null;
  liked_text: string | null;
  improve_text: string | null;
  feature_wishes: string[];
  feature_other: string | null;
  top_improvement: string | null;
  other_text: string | null;
  created_at: string;
  updated_at: string;
}

// Payload the form upserts (server-managed columns omitted; updated_at bumped by caller).
export interface FeedbackInput {
  overall_rating: number;
  scoring_clarity: number;
  return_intent: ReturnIntent;
  return_blocker: string | null;
  liked_text: string | null;
  improve_text: string | null;
  feature_wishes: string[];
  feature_other: string | null;
  top_improvement: string | null;
  other_text: string | null;
}

// Q3 — single choice. "unsure"/"no" reveal the optional blocker follow-up.
export const RETURN_INTENT_OPTIONS: { value: ReturnIntent; label: string }[] = [
  { value: 'yes', label: 'בטוח' },
  { value: 'probably', label: 'כנראה' },
  { value: 'unsure', label: 'לא בטוח' },
  { value: 'no', label: 'לא' },
];

export const RETURN_INTENT_SHOWS_BLOCKER: ReturnIntent[] = ['unsure', 'no'];

// Q6 — multi-select, capped at FEATURE_WISH_MAX. The stored value is the Hebrew
// label itself (text[]). The "other" option reveals the free-text feature_other field.
export const FEATURE_WISH_OPTIONS = [
  'טבלת דירוג גלובלית מול כל המשתתפים',
  'דירוג בין ליגות / קבוצות',
  'טבלה שמתעדכנת מהר יותר אחרי משחקים',
  'סיכום אחרי כל משחק: מי עלה, מי ירד ומה השתנה',
  'הסבר ברור יותר על הניקוד שקיבלתי',
  'תזכורות בוואטסאפ/טלגרם לפני דדליין',
  'שיתוף קל לוואטסאפ של טבלה / תוצאה מעניינת',
  'עוד סוגים של Side Bets',
  'טורניר מונדיאל או ספורט אחר',
  'אחר (טקסט חופשי)',
] as const;

export const FEATURE_WISH_OTHER = 'אחר (טקסט חופשי)';

// Q6 selection cap ("בחר עד 3").
export const FEATURE_WISH_MAX = 3;
